import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "jspdf-autotable";
import { useDispatch } from "react-redux";
import { errorToast } from "../../components/notifications/toast";
import Loader from "../../components/loaders/dot-loader";
import LoaderModal from "../../components/modals/loader-modal";
import { formatDate, statusColors } from "../../components/helper";
import { viewCreditAction } from "../../redux/actions/creditAction";
import CreateEditRouteCreditModal from "../../components/modals/createEditRouteCredit";

const ViewCreditDetails = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [storeDetails, setStoreDetails] = useState(null);
    const [creditDetails, setCreditDetails] = useState(null)
    const [loading, setLoading] = useState(true);
    const [isCreditModalOpen, setIsCreditModalOpen] = useState(false);
    const [editingRoute, setEditingRoute] = useState(null)
    const openModal = () => setIsCreditModalOpen(true);
    const closeModal = () => { setIsCreditModalOpen(false); setEditingRoute(null) };

    useEffect(() => {
        fetchstoreDetails();
    }, [id]);

    const fetchstoreDetails = async () => {
        dispatch(viewCreditAction({ id }, onSuccess, onError))
    };

    const onSuccess = (data) => {
        setCreditDetails(data.data.data)
        setStoreDetails(data.data.data.store);
        setLoading(false)
    }

    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
        setLoading(false)
    }


    return (
        <div className="flex items-center justify-center bg-gray-100" style={{ height: "95vh" }}>
            <div className="w-full mx-6 bg-white shadow-lg rounded-md overflow-auto" style={{ height: "95%" }}>

                <div className="flex flex-wrap justify-between items-center p-4 border-b sticky top-0 bg-white z-20">
                    <div className="flex gap-4">
                        <button onClick={() => navigate(-1)} className="text-blue-500 hover:text-blue-700 text-nowrap">
                            &lt; Back
                        </button>
                        <h1 className="text-lg font-medium text-start text-primary text-nowrap">Store Credit Details</h1>
                    </div>

                </div>
                <div className="flex md-lg:flex-row flex-col gap-3">
                    <div className="w-full sm:w-auto text-start p-4">
                        <label className="block text-sm font-medium mb-1">Image</label>
                        <img
                            src={storeDetails?.image}
                            alt={storeDetails?.name}
                            className="w-48 h-40 object-cover rounded-md truncate border fs_12"
                        />
                    </div>
                    <div className="flex flex-wrap items-center gap-4 pt-2 p-4">
                        <div className="w-full sm:w-auto text-start">
                            <label className="block text-sm font-medium mb-1">Code</label>
                            <div className="input-field w-full max-w-80 sm:max-w-80 md:w-80">{storeDetails?.code}</div>
                        </div>

                        <div className="w-full sm:w-auto text-start">
                            <label className="block text-sm font-medium mb-1">Name</label>
                            <div className="input-field w-full max-w-80 sm:max-w-80 md:w-80">{storeDetails?.name}</div>
                        </div>

                        <div className="w-full sm:w-auto text-start">
                            <label className="block text-sm font-medium mb-1">Customer Name</label>
                            <div className="input-field w-full max-w-80 sm:max-w-80 md:w-80">{storeDetails?.customer_name ?? "--"}</div>
                        </div>

                        <div className="w-full sm:w-auto text-start">
                            <label className="block text-sm font-medium mb-1">Mobile</label>
                            <div className="input-field w-full max-w-80 sm:max-w-80 md:w-80">{storeDetails?.customer_mobile ?? "--"}</div>
                        </div>

                        <div className="w-full sm:w-auto text-start">
                            <label className="block text-sm font-medium mb-1">Email</label>
                            <div className="input-field w-full max-w-80 sm:max-w-80 md:w-80">{storeDetails?.email ?? "--"}</div>
                        </div>

                        <div className="w-full sm:w-auto text-start">
                            <label className="block text-sm font-medium mb-1">Address</label>
                            <div className="input-field w-full max-w-80 sm:max-w-80 md:w-80">{storeDetails?.address ?? "--"}</div>
                        </div>

                    </div>

                </div>

                <div className="pt-6 p-4 flex flex-col md:flex-row gap-3 w-full">
                    <div className="w-full">
                        <div className="flex gap-3 justify-between mb-2">
                            <h2 className="text-lg text-start text-primary font-medium">Credit History By Routes</h2>
                            <button
                                type="button"
                                onClick={openModal}
                                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                            >
                                Add Route Credit
                            </button>
                        </div>
                        <div className="relative">
                            <div className="overflow-auto border border-gray-300 rounded-md" style={{ height: '30rem' }}>
                                <table className="w-full border-collapse">
                                    <thead>
                                        <tr className="bg-gray-100 sticky top-0">
                                            <th className="p-1 border border-gray-200 font-normal fs_15 text-left">#</th>
                                            <th className="p-1 border border-gray-200 font-normal fs_15 text-left">Code</th>
                                            <th className="p-1 border border-gray-200 font-normal fs_15 text-left">Name</th>
                                            <th className="p-1 border border-gray-200 font-normal fs_15 ">Total Amount</th>
                                            <th className="p-1 border border-gray-200 font-normal fs_15 text-center">Paid Amount</th>
                                            <th className="p-1 border border-gray-200 font-normal fs_15 text-center">Pending Amount</th>
                                            <th className="p-1 border border-gray-200 font-normal fs_15 text-center">Route Date</th>
                                            <th className="p-1 border border-gray-200 font-normal fs_15 text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="9" style={{ height: '30rem' }}>
                                                    <Loader />
                                                </td>
                                            </tr>
                                        ) : creditDetails?.creditRoutes?.length > 0 ? creditDetails?.creditRoutes?.map((credit, index) => (
                                            <tr key={credit.id} className="hover:bg-gray-50">
                                                <td className="p-1 border border-gray-200">{index + 1}</td>
                                                <td className="p-1 border border-gray-200 text-left">{credit.route.code}</td>
                                                <td className="p-1 border border-gray-200 text-left">{credit.route.name}</td>
                                                <td className="p-1 border border-gray-200 text-left">{credit.total_amount}</td>
                                                <td className="p-1 border border-gray-200 text-left">{credit.paid_amount}</td>
                                                <td className="p-1 border border-gray-200 text-left">{credit.pending_amount}</td>

                                                <td className="p-3 border border-gray-200 ">{formatDate(credit?.route?.createdAt)}</td>
                                                <td className="p-1 border border-gray-200 text-center">
                                                    <button
                                                        onClick={() => { openModal(); setEditingRoute(credit) }}
                                                        className="text-blue-500 hover:underline"
                                                    >
                                                        Edit
                                                    </button>
                                                </td>
                                            </tr>
                                        )) :
                                            <tr>
                                                <td colSpan="8" style={{ height: '27rem' }}>
                                                    <span className="text-gray-400 font-extralight"> No Data Found</span>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CreateEditRouteCreditModal
                isOpen={isCreditModalOpen}
                onClose={closeModal}
                fetchCredits={fetchstoreDetails}
                store_credit_id={id}
                store_id={storeDetails?.id}
                editingRoute={editingRoute}
                isEdit={editingRoute}
                setEditingRoute={setEditingRoute}
            />

            {loading &&
                <LoaderModal />
            }
        </div>
    );
};

export default ViewCreditDetails;